import {forwardRef} from 'react';
import {Autocomplete, Box, CircularProgress, TextField} from '@mui/material';

import {useGetCategories} from '../../apiHooks';
import {Category} from '../../types';

type Props = {
  value: Category | null;
  onChange: (value: Category | null) => void;
  label?: string;
  error?: string;
  fullWidth?: boolean;
  disabled?: boolean;
};

export const CategorySelect = forwardRef<HTMLInputElement, Props>(
  ({value, onChange, label, error, fullWidth, disabled}, ref) => {
    const {data: options = [], isPending} = useGetCategories();

    return (
      <Autocomplete
        ref={ref}
        value={value}
        options={options}
        loading={isPending}
        disabled={disabled}
        fullWidth={fullWidth}
        getOptionLabel={option => option.name || option.id}
        isOptionEqualToValue={(option, val) => option.id === val.id}
        onChange={(_, newValue) => onChange(newValue)}
        renderOption={(props, option) => (
          <Box
            component="li"
            {...props}
            key={option.id}
            display="flex"
            alignItems="center"
            gap={1.5}
          >
            {option.logoUrl && (
              <img
                src={option.logoUrl}
                alt=""
                width="auto"
                height={24}
                style={{flexShrink: 0}}
              />
            )}
            {option.name || option.id}
          </Box>
        )}
        renderInput={params => (
          <TextField
            {...params}
            label={label}
            error={!!error}
            helperText={error}
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isPending && <CircularProgress size={16} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              },
            }}
          />
        )}
      />
    );
  },
);
